import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { PaymentInvoice } = await import('@containers/Payment/PaymentInvoice');
    return {
        Component: PaymentInvoice,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
